export const devConfig = {
  environment: process.env.REACT_APP_NODE_ENV,
  // Mobile app - togglers
  isMobileApp: false,
  platform: "Web", // Web, Android, IOS
  debug: true,
  baseURL: process.env.REACT_APP_BASE_URL  
}
